import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    onboardingUrl: String,
    redirectUrl: String,
    widgetId: String
  }

  connect() {
    this.initWidget()
  }

  initWidget() {
    LemonwayWidget.init(
      this.onboardingUrlValue,
      this.widgetIdValue,
      {
        lang: "fr",
        onMyAccount: () => this.redirectToNextStep(false),
        onFinish: () => this.redirectToNextStep(true),
        onPageChange: () => window.scrollTo({
          top: 0,
          behavior: "smooth",
        })
      }
    )
  }

  redirectToNextStep(success = false) {
    const url = new URL(this.redirectUrlValue)

    if (success) {
      url.searchParams.set("status", "success")
    }

    window.location.replace(url)
  }
}
